module.exports = __webpack_public_path__ + "img/MEDIA079.5be63557.jpg";